"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M15.5 23h-8c-.879 0-2-1.122-2-3v-1h13v1c0 1.81-1.042 2.919-2.802 2.996L15.5 23Zm-8-22h8c1.879 0 3 1.122 3 2v1h-13V3c0-.838 1.021-1.899 1.879-1.993L7.5 1Zm-2 17h13V5h-13v13Zm11-18h-8c-2.43 0-4 1.57-4 4v17c0 1.43 1.57 3 4 3h8c1.43 0 3-1.57 3-3V4c0-2.349-1.467-3.894-2.857-3.995L16.5 0Zm-4 9v2h-1V9h1Zm.5-7a.5.5 0 0 1 .09.992L13 3h-2a.5.5 0 0 1-.09-.992L11 2h2Zm-1.5 12h1v-2h-1v2Zm1-6-2 1v6l.216.007c.187.005.476.007.784-.007l2-1V8l-.302-.009A11.546 11.546 0 0 0 12.5 8Zm3 6c0 .098-3.675 2-3.675 2l-1.57-.909C9.394 14.587 8.5 14.051 8.5 14V8L12 7l3.5 1v6ZM12 20a1 1 0 1 1 .002 1.998A1 1 0 0 1 12 20Zm.04-3.006-.719.006-.084-.053c-.807-.492-3.525-1.832-3.725-2.833L7.5 14V7l4-1 .681-.003L12.5 6l4 1v7c0 1.048-3.477 2.542-4.179 3a7.633 7.633 0 0 0-.28-.006Z",
    clipRule: "evenodd"
  })]
});